export default __webpack_public_path__ + "static/media/tienes_una_orden.9a9d7b8c.mp3";